import React, { Fragment, useState } from 'react';
import { Col, Card, CardHeader, Row } from 'reactstrap';
import CountUp from 'react-countup';
import { H6, Image, LI, UL } from '../../../../AbstractElements';
import { BOD, Contact, ContactUsNumber, DDMMYY, Designer, Email, Follower, Following, LocationDetails, MarekjecnoMailId, MarkJecno, Location } from '../../../../Constant';

const PatientInfo = ({data}) => {
  const [url, setUrl] = useState('');

  const readUrl = (event) => {
    if (event.target.files.length === 0) return;
    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      setUrl(reader.result);
    };
  };

  return (
    <Fragment>
      <Col sm='12'>
        <Card className='hovercard text-center'>
          <CardHeader className='border-0'></CardHeader>
          {/* <CardHeader className='cardheader'></CardHeader> */}
          {/* {data.map((data)=>( */}
            <div className='info'>
            <Row className='step3' data-intro='This is the your details'>

            <Col sm='12' lg='4' className='order-sm-0 order-xl-1'>
                <div className='user-designation'>
                  <div className='title'>
                    <a href='#'>
                      {`${data.first_name} ${data.surname}`}
                    </a>
                  </div>
                  <div className='desc mt-2'>{data.profession? data.profession : "Profession Not Available"}</div>
                </div>
              </Col>
            
              <Col sm='6' lg='4' className='order-sm-1 order-xl-0'>
                <Row>
                  <Col md='6'>
                    <div className='ttl-info'>
                      <H6>
                        <i className='fa fa-envelope me-2'></i> {Email}
                      </H6>
                      <span>{data.email? data.email : "-"}</span>
                    </div>
                  </Col>
                  <Col md='6'>
                    <div className='ttl-info ttl-sm-mb-0'>
                      <H6>
                        <i className='fa fa-calendar me-2'></i>
                        {BOD}
                      </H6>
                      <span>{data.dob}</span>
                    </div>
                  </Col>
                </Row>
              </Col>

              
              
              <Col sm='6' lg='4' className='order-sm-2 order-xl-2'>
                <Row>
                  <Col md='6'>
                    <div className='ttl-info  ttl-xs-mt'>
                      <H6>
                        <i className='fa fa-phone me-2'></i>
                        {Contact}
                      </H6>
                      <span>{data.phone}</span>
                    </div>
                  </Col>
                  <Col md='6'>
                    <div className='ttl-info ttl-sm-mb-0'>
                      <H6>
                        <i className='fa fa-location-arrow me-2'></i>
                        {Location}
                      </H6>
                      <span>{data.address?data.address:"-"}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='step3 mt-5' data-intro='This is the your details'>
              <Col sm='6' lg='4' className='order-sm-1 order-xl-0'>
                <Row>
                  <Col md='6'>
                   
                  </Col>
                  <Col md='6'>
                    <div className='ttl-info  ttl-sm-mb-0'>
                      <H6>
                        {/* <i className='fa fa-calendar me-2'></i> */}
                        {"Relation Contact Name"}
                      </H6>
                      <span>{data.primary_contact_name?data.primary_contact_name : "-"}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col sm='12' lg='4' className='order-sm-0 order-xl-1'>
                
              </Col>
              <Col sm='6' lg='4' className='order-sm-2 order-xl-2'>
                <Row>
                  <Col md='6'>
                    <div className='ttl-info ttl-xs-mt'>
                      <H6>
                        {/* <i className='fa fa-phone me-2'></i> */}
                        {"Age"}
                      </H6>
                      <span>{data.age}</span>
                    </div>
                  </Col>
                  <Col md='6'>
            
                  </Col>
                </Row>
              </Col>
            </Row>
            
          </div>
          {/* ))} */}
        </Card>
      </Col>
    </Fragment>
  );
};

export default PatientInfo;

